"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShowRedDot = getShowRedDot;
const store_1 = require("../../store");
/**
 * Returns whether the red dot should be shown for a collection summary.
 * - If the full collection model is loaded, recompute from live data
 *   (user may have edited it) and update the cached summary value.
 * - If the collection is NOT loaded and the summary has a value, use it as-is.
 * - If the collection is NOT loaded and the summary has no value, return false.
 */
function getShowRedDot(summary) {
    const collection = store_1.AppStore.Collection.get(summary.revision);
    if (collection != null) {
        summary.missingTrueSizeCapture = collection.isMissingTrueSize();
        return summary.missingTrueSizeCapture;
    }
    if (summary.missingTrueSizeCapture != null) {
        return summary.missingTrueSizeCapture;
    }
    return false;
}
//# sourceMappingURL=is.missing.true.size.js.map